import {Plural} from '@lingui/macro';
import React, {useEffect, useState} from 'react';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {useUnmountCancelToken} from '../../../srcCommon/helpers/hookHelpers';
import {useAppSelector} from '../../helpers/reduxHelpers';
import {
  ApiCustomFieldImpactedRules,
  CustomFieldImpactedRule,
  CustomFieldModel,
} from '../../models/api/customFieldModel';
import {fetchApiAsync} from '../../services/http/http';
import {getCompanyUrl} from '../../store/data/company/companySelectors';

/*
 * Types.
 */

interface CustomFieldImpactOnRuleProps {
  customField: CustomFieldModel;
  onImpactedRulesFetched?: HandlerOf<number>;
}

/*
 * Component.
 */

export const CustomFieldImpactOnRule = ({
  customField,
  onImpactedRulesFetched,
}: CustomFieldImpactOnRuleProps) => {
  const [impactedRules, setImpactedRules] = useState<ReadonlyArray<CustomFieldImpactedRule>>([]);
  const cancelToken = useUnmountCancelToken();
  const companyUrl = useAppSelector(getCompanyUrl);

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        const fetchedImpactedRules = await fetchApiAsync(
          ApiCustomFieldImpactedRules,
          `${companyUrl}/custom_fields/${customField.id}/impacted_rule_bundles`,
          {
            cancelToken,
          },
        );

        setImpactedRules(fetchedImpactedRules);
        if (onImpactedRulesFetched) {
          onImpactedRulesFetched(fetchedImpactedRules.length);
        }
      } catch {
        // TODO: this should show an error to the user.
      }
    };
    fetchDataAsync();
  }, [customField, cancelToken, companyUrl, onImpactedRulesFetched]);

  return (
    <>
      {impactedRules.length}{' '}
      <Plural
        id="custom-fields-rule-impact-count"
        value={impactedRules.length}
        zero="rules"
        one="rule"
        other="rules"
      />
    </>
  );
};
